import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static password(control: AbstractControl): ValidationErrors | null {
    const pattern = /^.{4,}$/;
    const value = control.value;

    return pattern.test(value) ? null : { password: true };
  }

  static tel(control: AbstractControl): ValidationErrors | null {
    const pattern = /(^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/;
    const value = control.value;

    return pattern.test(value) ? null : { tel: true };
  }

  static account(control: AbstractControl): ValidationErrors | null {
    const pattern = /^[0-9]+$/;
    const value = control.value.replace(/-/g, ''); // 하이픈 제거

    return pattern.test(value) ? null : { account: true };
  }

  static isEqual(field: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const compareValue = control.root.get(field)?.value;
      return value === compareValue ? null : { equal: true };
    };
  }
}
